import { useTranslation } from 'next-i18next';
import React from 'react';
import toast from 'react-hot-toast';

import { useArchiveSupplier } from '@/modules/settings/company/apiHooks';
import AddEditSupplier from '@/modules/settings/company/components/Suppliers/AddEditSupplier';
import { ICompanySettings } from '@/modules/settings/company/types';
import EditAndDelete from '@/shared/components/atoms/EditAndDelete';
import ConfirmationModal from '@/shared/components/molecules/ConfirmationModal';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

const SupplierActions: React.FC<{ supplier: ICompanySettings.ISupplier }> = ({
  supplier: { id, ...supplier },
}) => {
  const { t } = useTranslation();

  const { openModal } = useModal();

  const { mutate: archive } = useArchiveSupplier();

  const onEditClick = () => {
    openModal(<AddEditSupplier id={id} defaultValues={supplier} />, {
      variant: 'full',
      title: t('edit-supplier'),
    });
  };

  const onDeleteClick = () => {
    openModal(
      <ConfirmationModal
        variant='danger'
        header={t('deactivate-supplier-confirmation')}
        message={t('deactivate-supplier-warning')}
        confirmText={t('deactivate')}
        dismissText={t('back')}
        reverseButtonOrder
        preferredAction='dismiss'
        onConfirm={() => {
          archive(id, {
            onSuccess: () =>
              toast.success(t('supplier-deactivated-successfully')),
          });
        }}
      />
    );
  };

  return (
    <EditAndDelete
      onEditClick={onEditClick}
      onDeleteClick={onDeleteClick}
      deleteText={t('deactivate')}
      id={id}
    />
  );
};

export default SupplierActions;
